import store from '@/store/index'
export function permission (el, binding) {
  var permission = store.getters['Profile/getPermission']
  var group = store.getters['Profile/getGroup']
  if (permission.indexOf(binding.value) !== -1 || group.id === 1) {
    el.style.display = ''
  } else {
    el.style.display = 'none'
  }
}



// WEBPACK FOOTER //
// ./src/directives/directive-permission.js